<template>
  <div class="coupon-item">
    <div class="item-wrapper " :class="couponData.state.value ? 'color__'+couponData.color.text : 'color__gray'">
      <div class="coupon-type">{{ couponData.coupon_type.text }}</div>
      <div class="tip dis-flex flex-dir-column flex-x-center">
        <div v-if="couponData.coupon_type.value == 10" style="margin-top:15px">
          <p class="f-30" style="display:inline-block">￥</p>
          <p class="money"  style="display:inline-block">{{ couponData.reduce_price }}</p>
        </div>
        <p class="money" v-if="couponData.coupon_type.value == 20">{{ couponData.discount }}折</p>
        <p class="pay-line">满{{ couponData.min_price }}元可用</p>
      </div>
      <div class="split-line"></div>
      <div class="content dis-flex flex-dir-column flex-x-between">
        <div class="title">{{ couponData.name }}</div>
        <div class="bottom">
          <div class="time flex-box">
            <p v-if="couponData.expire_type == 10&&tp=='coupon'">领取{{ couponData.expire_day }}天内有效</p>
            <p
              v-if="couponData.expire_type == 10&&tp=='mycoupon' || couponData.expire_type == 20"
            >{{ couponData.start_time.text }}~{{ couponData.end_time.text }}</p>
          </div>
          <button
            class="receive"
            v-if="couponData.state.value&&tp=='coupon'"
            @click="add(couponData.coupon_id)"
            :data-coupon-id="couponData.coupon_id"
          >立即领取</button>
          <div class="receive state" v-else>
            <p>{{ couponData.state.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import { Tab, Tabs } from "vant";
import Vue from "vue";
Vue.use(Tab).use(Tabs);
export default {
  components: {},
  props: ["couponData","tp"],
  data() {
    return {};
  },
  created() {

  },
  activated() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    add(id){
      this.$emit("addcoupon",id)
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../style/skin.less");
.coupon-item {
  position: relative;
  overflow: hidden;
  margin-bottom: 11px;
  .item-wrapper {
    width: 100%;
    display: flex;
    background: @white;
    border-radius: 4px;
    color: @white;
    height: 90px;
    .coupon-type {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      width: 64px;
      padding: 3px 0;
      background: #a771ff;
      font-size: 10px;
      text-align: center;
      color: @white;
      transform: rotate(45deg);
      transform-origin: 32px 32px;
    }

    .content {
      flex: 1;
      padding: 15px 10px;
      border-radius: 8px 0 0 8px;
      .title {
        font-size: 19px;
      }
        .bottom{
          display: flex;
          margin-top: 10px;
          overflow: hidden;
          width: 100%;
        }
      .bottom .time {
        font-size: 12px;
        vertical-align: middle;
        line-height: 23px;
        height: 23px;
        float: left;
      }

      .bottom .receive {
        margin-left: 60px;
        height: 23px;
        width: 70px;
        text-align: center;
        border: 1px solid @white;
        background: transparent;
        border-radius: 15px;
        color: @white;
        font-size: 12px;
        vertical-align: middle;
      }

      .bottom .receive.state {
        border: none;
      }
    }

    .tip {
      position: relative;
      flex: 0 0 32%;
      text-align: center;
      border-radius: 0 8px 8px 0;
      .money {
        font-weight: bold;
        font-size: 26px;
      }

      .pay-line {
        font-size: 11px;
      }
    }

    .split-line {
      position: relative;
      flex: 0 0 0;
      border-left: 2px solid @white;
      margin: 0 5px 0 3px;
      background: @white;
    }

    .split-line:before,
    .split-line:after {
      content: "";
      position: absolute;
      width: 12px;
      height: 6px;
      background: #f7f7f7;
      left: -7px;
      z-index: 1;
    }

    .split-line:before {
      border-radius: 0 0 8px 8px;
      top: 0;
    }

    .split-line:after {
      border-radius: 8px 8px 0 0;
      bottom: 0;
    }
  }
  .color__blue {
    background: linear-gradient(-125deg, #57bdbf, #2f9de2);
  }

  .color__red {
    background: linear-gradient(-128deg, #ff6d6d, #ff3636);
  }

  .color__violet {
    background: linear-gradient(-113deg, #ef86ff, #b66ff5);
  }

  .color__violet .coupon-type {
    background: #55b5ff;
  }

  .color__yellow {
    background: linear-gradient(-141deg, #f7d059, #fdb054);
  }

  .color__gray {
    background: linear-gradient(-113deg, #bdbdbd, #a2a1a2);
  }

  .color__gray .coupon-type {
    background: #9e9e9e;
  }
}
</style>